// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RoundDetailClassic_wrapper_1U9dR","matchesLinkWrapper":"RoundDetailClassic_matchesLinkWrapper_2ZMQK"};